module.exports = __webpack_public_path__ + "static/media/heart-full.fbbe3f46.webp";